import { createAxios } from '../../lib/axiosFactory';
import { errorParser } from '../../lib/response/errorParser';

export const state = {};

export const getters = {};

export const actions = {
  async updateOptOutSettings({ commit, state }, payload: any) {
    try {
      const requestBody = {
        data: {
          type: 'optOutSettings',
          attributes: payload
        }
      };

      const response = await createAxios().patch(
        'backend/mobiz-admin-optouts-update',
        requestBody
      );

      return { success: true, errors: {}, body: response.data };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  }
};
export const mutations = {};
